import React from "react";
import { Box, IconButton, Modal, Typography } from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
import { T, FONT } from "./shared";

export const isImageDoc = (url) => /\.(png|jpe?g|webp|gif|avif)(\?|$)/i.test(String(url || ""));

// Document preview on the page itself, like the campaign pages' Document section (MUI Modal with a
// close button). Images show whole; PDFs show in a frame, with "Open in new tab" for phones whose
// browser can't render PDFs inline.
const DocumentModal = ({ doc, onClose }) => {
  const url = doc?.url || "";
  const image = isImageDoc(url);
  return (
    <Modal open={Boolean(doc)} onClose={onClose} sx={{ display: "flex", alignItems: "center", justifyContent: "center", p: "12px" }}>
      <Box
        sx={{
          position: "relative",
          width: image ? "auto" : "min(900px, 100%)",
          maxWidth: "100%",
          height: image ? "auto" : "min(90vh, 1100px)",
          maxHeight: "90vh",
          bgcolor: "#FFFFFF",
          borderRadius: "14px",
          overflow: "hidden",
          outline: "none",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: "12px", pl: "16px", pr: "8px", py: "8px", borderBottom: `1px solid ${T.sand}` }}>
          <Typography sx={{ flex: 1, minWidth: 0, fontFamily: FONT, fontWeight: 700, fontSize: "14px", color: T.ink, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
            {doc?.displayTitle || "Document"}
          </Typography>
          {!image && url && (
            <Box component="a" href={url} target="_blank" rel="noopener noreferrer" sx={{ fontFamily: FONT, fontWeight: 700, fontSize: "12px", color: T.red, textDecoration: "none", whiteSpace: "nowrap" }}>
              Open in new tab
            </Box>
          )}
          <IconButton aria-label="Close document" onClick={onClose} size="small" sx={{ bgcolor: "rgba(0,0,0,0.06)", "&:hover": { bgcolor: "rgba(0,0,0,0.12)" } }}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>
        {url &&
          (image ? (
            <Box component="img" src={url} alt={doc?.displayTitle || "Document"} sx={{ display: "block", maxWidth: "100%", maxHeight: "calc(90vh - 52px)", width: "auto", height: "auto", objectFit: "contain", m: "0 auto" }} />
          ) : (
            <Box component="iframe" src={url} title={doc?.displayTitle || "Document"} sx={{ flex: 1, width: "100%", border: "none", background: T.cream }} />
          ))}
      </Box>
    </Modal>
  );
};

export default DocumentModal;
